import { Box, makeStyles } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { moveNextPage, updateCreatorOnboarding } from "../../../../../store/actions/creator/creatorOnBoarding";
import UtilService from "../../../../../helper/service";
import { useHistory, useLocation } from "react-router";
import OnboardingBtn from "../../../../atoms/creator/onboardingEnterBtn";

const useStyles = makeStyles((theme) => ({
  title: {
    marginTop: 20,
    marginBottom: 20,
    fontFamily: 'Spartan-bold',
    fontSize: (props: any) => (props.height < 770 || props.width < 1200) ? 36 : 48,
    color: '#212D40',
    textAlign: 'center',
    '@media (max-width: 1400px)': {
      fontSize: 38,
    },
    '@media (max-width: 600px)': {
      fontSize: '25px!important',
    },
  },
  img: {
    marginBottom: theme.spacing(3),
    width: 324,
    height: 351,
    '@media (max-width: 1400px)': {
      width: 250,
      height: 240,
    },
  },
  description: {
    marginBottom: -15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      maxWidth: 540,
      margin: 0,
      textAlign: 'center',
      fontFamily: 'roboto-light',
      fontSize: (props: any) => props.height < 770 ? 20 : 30,
      color: '#212D40',
      lineHeight: 1.25,
      '@media (max-width: 600px)': {
        fontSize: '15px!important',
      },
    }
  },
  btn: {
    fontFamily: 'roboto-regular',
    fontSize: 20,
    width: 194,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  }
}));

const Module1Finish = () => {

  const size = UtilService.useWindowSize();
  const classes = useStyles(size);
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userPreferences } = useSelector((state: any) => state.creatorOnBoarding);
  const { activepage } = userPreferences;
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);
    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  });

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'm1s7');
  }, []);

  const handleUserKeyPress = (event: any) => {
    if (event.keyCode === 13) {
      goNext();
    }
  };

  const goNext = () => {
    const request = {
      user_id: loginUserData.user_id,
      preference_id: userPreferences.module1finish.id,
      preference_name: 'MODULE1FINISH',
      preference_information: 'true',
    };
    dispatch(updateCreatorOnboarding(apolloClient.client, request));

    if (Number(activepage.value) < 9) {
      const reqActivePage = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activepage.id,
        preference_name: 'ACTIVEPAGE',
        preference_information: '9',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActivePage));

      const reqActiveStep = {
        user_id: loginUserData.user_id,
        preference_id: userPreferences.activestep.id,
        preference_name: 'ACTIVESTEP',
        preference_information: '1',
      };
      dispatch(updateCreatorOnboarding(apolloClient.client, reqActiveStep));
    }

    dispatch(moveNextPage(9))
  };

  return (
    <>
      <div className={classes.title}>
        Congrats! You’ve completed Module 1!
      </div>

      <Box justifyContent="center" display="flex">
        <img src="/assets/icons/final.svg" alt="avatar" className={classes.img} />
      </Box>

      <div className={classes.description}>
        <p>
          In Module 2, you’ll measure Immersion
          on your first piece of content.
        </p>
      </div>

      <OnboardingBtn
        goNext={goNext}
        hiddenBack
        title={'Let’s Go!'}
      />

    </>
  )
};

export default Module1Finish;